<div class="counter-container">
  @for (value of values; track value.id) {
    <div class="hidden-value">{{ value.value }}</div>
  }
  <div class="counter" [class.sliding]="values.length > 1" [class.reverse]="values[0]?.value === value">
    @for (value of values; track value.id) {
      <div class="counter-item">
        {{ value.value }}
      </div>
    }
  </div>
</div>
